import { call, put, takeEvery } from "redux-saga/effects";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";

import * as actionTypes from "Redux/Actions/actionTypes";
import UpdateApplicationNotesReview from "../../Communication/ApiClasses/UpdateApplicationNotesReview";
import {
  updateApplicationNotesReviewSuccess,
  updateApplicationNotesReviewError,
} from "../Actions/ApplicationNotesAction";

// worker
function* handleUpdateApplicationNotesReview(action) {
  yield put(
    doLoadingStart(
      `${actionTypes.UPDATE_APPLICATION_NOTES_REVIEW_REQUEST}_SAGA`
    )
  );
  const updateApplicationNotesReviewApi = new UpdateApplicationNotesReview(
    action.noteId,
    action.reviewData
  );
  try {
    const result = yield call(updateApplicationNotesReviewApi.getData);
    yield put(updateApplicationNotesReviewSuccess(result.data || result));
    yield call(action.callback, result);
  } catch (error) {
    yield put(
      updateApplicationNotesReviewError(error.response?.data || error.message)
    );
    yield call(action.callback, error.response);
  } finally {
    yield put(
      doLoadingFinish(
        `${actionTypes.UPDATE_APPLICATION_NOTES_REVIEW_REQUEST}_SAGA`
      )
    );
  }
}

// watcher
export default function* updateApplicationNotesReviewWatcherSaga() {
  yield takeEvery(
    actionTypes.UPDATE_APPLICATION_NOTES_REVIEW_REQUEST,
    handleUpdateApplicationNotesReview
  );
}
